module.exports = __webpack_public_path__ + "static/media/footer-logo.d8859672.svg";